import React from "react";
import "./SattaCard.css";

const SattaCard = ({ title, subtitle, description, buttonText }) => {
  return (
    <div className="satta-card">
      <div className="satta-card-content">
        <h3>{title}</h3>
        {subtitle && <p className="satta-subtitle">{subtitle}</p>}
        <p>{description}</p>
      </div>
      {buttonText && <button>{buttonText}</button>}
    </div>
  );
};

export default SattaCard;
